import Vue from 'vue';
import defaultState from './defaultState';
import * as C from '../constants';

export default {

  /**
   * @param state
   * @param payload
   */
  [C.SNACKBAR_SHOW](state, payload) {
    Vue.set(state, 'element', {
      ...state.element,
      ...payload,
      show: true,
    });
  },

  [C.SNACKBAR_HIDE](state) {
    Object.assign(state, defaultState());
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/snackbar/mutations.js